import Nullstack from 'nullstack';
export default function IconSatellite({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-satellite",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
  }), "   ", Nullstack.element("path", {
    d: "M6 10l-3 3l3 3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M10 6l3 -3l3 3l-3 3"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "12",
    x2: "13.5",
    y2: "13.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 21a6 6 0 0 0 6 -6"
  }), " ");
}